import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IncotermsComponent} from "../../incoterms.component";
import {IncotermService} from "../../../../../../core/services/parameters/incoterm.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-icoterms.component.html',
  styleUrls: ['./confirm-delete-icoterms.component.scss']
})
export class ConfirmDeleteIcotermsComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<IncotermsComponent>,
    private incotermService : IncotermService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.incotermService.deleteIncoterm(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      });
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
